<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12 vh-header d-flex flex-column pr-0">
        <div class="card flex-1-auto h-100 overflow-auto">
            <div class="card-header card-header-with-button">
              <h5>{{$t('STEPBUTTON')}}</h5>
              <button type="button" class="btn-bis btn-primary" @click="showModal()">{{$t('NEW')}}</button>
            </div>
            <div class="card-body" v-if="data.root == null || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="table-responsive h-100 flex-1-auto" v-if="data.root != null && data.root.length">
              <table class="table table-bis">
                <thead>
                  <tr>
                    <th>{{$t('LABEL')}}</th>
                    <th>{{$t('NEXTSTEP')}}</th>
                    <th>{{$t('ISFINAL')}}</th>
                    <th>{{$t('SKIPCHECK')}}</th>
                    <th>{{$t('STATUS')}}</th>
                    <th>{{$t('ORDERNUM')}}</th>
                    <th>{{$t('ACTIONS')}}</th>
                  </tr>
                </thead>
                <draggable v-model="data.root" @start="drag=true" @end="drag=false" @change="changeOrder" tag="tbody">
                  <template v-for="item in data.root">
                    <tr :key="item.stepButtonId" aria-rowindex="1" class=" table-ellipsis">
                        <td>{{item.label}}</td>
                        <td>{{item.stepName}}</td>
                        <td>{{item.isFinal}}</td>
                        <td>{{item.skipCheck}}</td>
                        <td>{{(item.status != null) ? $t(item.status.toUpperCase()) : ''}}</td>
                        <td>{{item.orderNum}}</td>
                        <td class="table-buttons">
                          <b-button type="reset" class="btn-table table-btn-tertiary" @click="showModal(item)">{{$t('EDIT')}}</b-button>
                          <b-button type="reset" class="btn-table table-btn-delete ml-2" @click="deleteRow(item.stepButtonId)">{{$t('DELETE')}}</b-button>
                        </td>
                    </tr>
                  </template>
                </draggable>
              </table>
            </div>
            <pagination
                v-bind:totalCount="data.totalCount"
                v-model="pagination">
            </pagination>
          </div>
        </div>
    </div>
    <stepbuttonsform v-model="formData" v-bind:stepId="$route.params.stepId" v-bind:flowId="$route.params.flowId"
            v-on:close="formData = null; getData()"></stepbuttonsform>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Api from '@/api/flow/StepButton.js';
import StepButtonsForm from './Form.vue';

export default {
    name: 'StepButtons',
    components:
    {
        stepbuttonsform: StepButtonsForm,
    },
    data()
    {
        const me = this;

        me.formDataField = {
            label: '',
            nextStepId: null,
        };

        return {
            loading: true,
            data: {},
            formError: {},
            formData: {...me.formDataField},
            pagination: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            searchTimeout: false,
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
  {
      async getData()
      {
          const me = this;
          try
          {
              me.loading = true;
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.data = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      async changeOrder(item)
        {
            const me = this;
            try
            {
                const { moved } = item;

                const movedData = moved.element;

                let newIndex = moved.newIndex * 10 + 1;

                if (moved.newIndex === me.data.root.length - 1)
                {
                    newIndex += 10;
                }

                const data = await Api.save(
                    {
                        id: movedData.stepButtonId,
                        orderNum: newIndex,
                    },
                );
                me.$notify.notice(data);
                me.getData();
            }
            catch (e)
            {
                console.log(e);
                me.$notify.notice(e);
            }
        },
      async deleteRow(id)
      {
          const me = this;
          me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHURE'),
                  async btnAction()
                  {
                      const data = await Api.deleteRow({ id });
                      me.$notify.notice(data);
                      me.getData();
                  },
              });
      },
      showModal(item)
      {
          const me = this;
          if (typeof item == null)
          {
              item = {};
          }
          me.formData = { ...item };
      },
  },
    watch:
    {
        pagination:
        {
            deep: true,
            handler()
            {
                const me = this;

                if (me.searchTimeout !== false)
                {
                    clearTimeout(me.searchTimeout);
                }

                me.searchTimeout = setTimeout(() =>
                {
                    me.getData();
                    me.searchTimeout = false;
                }, 300);
            },
        },
    },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParams()
      {
          const me = this;
          const data = { ...me.pagination };
          data.start = (data.currentPage - 1) * data.limit;
          data.stepId = me.$route.params.stepId;
          return data;
      },
  },
};
</script>
